<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M9.51504 0.0115662C4.23306 0.263064 0.0648331 4.66193 0.0808566 9.94989C0.0857354 11.5605 0.474557 13.0806 1.16046 14.4238L0.107355 19.5357C0.050388 19.8123 0.299781 20.0544 0.574477 19.9893L5.58353 18.8026C6.87043 19.4436 8.3159 19.8139 9.84569 19.8372C15.2444 19.9197 19.7459 15.633 19.9142 10.2363C20.0946 4.45142 15.3201 -0.264899 9.51504 0.0115662ZM15.4919 15.4111C14.025 16.8781 12.0745 17.686 10 17.686C8.78527 17.686 7.6223 17.4134 6.54327 16.8759L5.84569 16.5284L2.77463 17.256L3.42107 14.118L3.0774 13.445C2.51725 12.348 2.23322 11.1617 2.23322 9.91918C2.23322 7.84459 3.0411 5.89421 4.50804 4.42722C5.96188 2.97338 7.94411 2.15236 10.0001 2.15236C12.0747 2.15241 14.025 2.96028 15.492 4.42717C16.9589 5.89412 17.7668 7.84449 17.7668 9.91904C17.7668 11.9751 16.9457 13.9573 15.4919 15.4111Z" 
    fill="#7AD06D"/>
    <path d="M14.8139 12.0701L12.8926 11.5184C12.64 11.4459 12.368 11.5175 12.1839 11.7051L11.7141 12.1838C11.516 12.3856 11.2153 12.4505 10.9531 12.3444C10.0442 11.9766 8.13232 10.2767 7.64405 9.42635C7.50319 9.18107 7.52648 8.87443 7.69944 8.65062L8.10964 8.11993C8.27036 7.91201 8.30427 7.63277 8.19799 7.39242L7.38964 5.56415C7.19602 5.12626 6.63644 4.99879 6.27086 5.30797C5.73462 5.76151 5.09837 6.45071 5.02102 7.21424C4.88466 8.56041 5.46198 10.2574 7.64515 12.295C10.1673 14.649 12.187 14.96 13.5021 14.6415C14.2479 14.4608 14.844 13.7365 15.2202 13.1435C15.4767 12.7392 15.2742 12.2023 14.8139 12.0701Z" 
    fill="#7AD06D"/>
  </svg>
</template>

<script>
export default {
  name: 'WhatsAppPlatformIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>